import { Injectable, Injector } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { MenuItem } from '@awp/models';
import { ContentProvider } from '@awp/content';
import { take } from 'rxjs/operators';
import { MenuService } from '@awp/app-common';

@Injectable()
export class MenuHalService implements MenuService {

  private _contentProvider: ContentProvider;
  private _content$ = new ReplaySubject<MenuItem[]>(1);
  public values = this._content$.asObservable();

  constructor(private injector: Injector) {
    this.provider.get<Array<any>>('navMenu.menuItems')
      .pipe(take(1))
      .subscribe(data => {
        const menuItems = data.map(p => {
          return {
            name: p.name,
            url: p.pageDetails.pageUrl,
            parentUrl: p.pageDetails.parentUrl,
            iconName: p.pageDetails.iconName,
            hideInNav: p.pageDetails.hideInNav,
            contentUrl: p._link != null && p._link.self != null ? p._link.self.href : null,
            properties: p.pageProperties
          } as MenuItem;
        })

        this._content$.next(menuItems);
      });
  }

  get provider(): ContentProvider {
    if (this._contentProvider == null) {
      this._contentProvider = this.injector.get(ContentProvider);
    }
    return this._contentProvider;
  }

}
